(() => {
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

  const addWorkingDays = (date, days) => {
    const result = new Date(date);
    let added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result)) added += 1;
    }

    return result;
  };

  const dispatchDate = (now, cutoffHour, cutoffMinute) => {
    const dispatch = new Date(now);
    dispatch.setHours(cutoffHour, cutoffMinute, 0, 0);

    if (now > dispatch || isWeekend(now)) {
      do {
        dispatch.setDate(dispatch.getDate() + 1);
        dispatch.setHours(cutoffHour, cutoffMinute, 0, 0);
      } while (isWeekend(dispatch));
    }

    return dispatch;
  };

  const friendlyDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const target = new Date(date);
    target.setHours(0, 0, 0, 0);

    if (target.getTime() === tomorrow.getTime()) return 'tomorrow';
    return dayNames[target.getDay()];
  };

  const friendlyHours = (now, dispatch) => {
    const milliseconds = Math.max(0, dispatch.getTime() - now.getTime());
    const hours = Math.max(1, Math.ceil(milliseconds / (1000 * 60 * 60)));
    return `${hours} ${hours === 1 ? 'hour' : 'hours'}`;
  };

  const updateEstimate = (panel) => {
    const dateTarget = panel.querySelector('[data-okodoko-delivery-date]');
    const hoursTarget = panel.querySelector('[data-okodoko-delivery-hours]');
    if (!dateTarget) return;

    const cutoffHour = Number(panel.dataset.cutoffHour) || 12;
    const cutoffMinute = Number(panel.dataset.cutoffMinute) || 0;
    const now = new Date();
    const dispatched = dispatchDate(now, cutoffHour, cutoffMinute);
    const delivery = addWorkingDays(dispatched, 1);

    if (hoursTarget) hoursTarget.textContent = friendlyHours(now, dispatched);
    dateTarget.textContent = friendlyDate(delivery);
  };

  const formatMoney = (pence) => {
    const pounds = Math.max(0, pence) / 100;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      currencyDisplay: 'narrowSymbol',
    }).format(pounds);
  };

  const updateDeliveryProgressFromCart = (cart) => {
    if (!cart) return;

    const threshold = 2000;
    const total = Number(cart.total_price) || 0;
    const itemCount = Number(cart.item_count) || 0;
    const remaining = threshold - total;
    const progress = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));
    const truckProgress = Math.min(92, Math.max(8, progress));

    document.querySelectorAll('.okodoko-cart-delivery-progress').forEach((panel) => {
      const message = panel.querySelector('p');
      panel.style.setProperty('--okodoko-cart-progress', `${progress}%`);
      if (message) {
        message.textContent = remaining > 0
          ? `Spend ${formatMoney(remaining)} more to unlock free delivery.`
          : 'Free delivery unlocked.';
      }
    });

    document.querySelectorAll('.okodoko-free-delivery-circle').forEach((circle) => {
      const label = circle.querySelector('.okodoko-free-delivery-circle__label');
      circle.classList.toggle('okodoko-free-delivery-circle--hidden', itemCount === 0);
      circle.style.setProperty('--okodoko-circle-progress', `${progress}%`);
      circle.style.setProperty('--okodoko-truck-progress', `${truckProgress}%`);
      circle.setAttribute(
        'aria-label',
        remaining > 0 ? `Add ${formatMoney(remaining)} to unlock free delivery` : 'Free delivery unlocked'
      );
      if (label) {
        label.textContent = remaining > 0
          ? `Add ${formatMoney(remaining)} to unlock free delivery`
          : 'Free delivery unlocked';
      }
    });
  };

  const refreshCartProgress = () => {
    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then(updateDeliveryProgressFromCart)
      .catch(() => {});
  };

  const init = () => {
    document.querySelectorAll('[data-okodoko-delivery-clock]').forEach(updateEstimate);
  };

  const initWithCart = () => {
    init();
    refreshCartProgress();
  };

  document.addEventListener('DOMContentLoaded', initWithCart);
  document.addEventListener('cart:updated', initWithCart);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, initWithCart);
  }

  document.addEventListener('submit', (event) => {
    if (event.target?.matches?.('form[action*="/cart/add"]')) {
      window.setTimeout(initWithCart, 450);
      window.setTimeout(initWithCart, 1100);
    }
  }, true);

  window.setInterval(init, 1000 * 60 * 5);
})();
